import styled from "styled-components";

export const ArchiveConstructionButton = styled.span`
  font-family: Open Sans;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  color: ${({ theme }) => theme.colors.surface.onSurface};
  float: left;
  margin: 8px 0 0 28px;
  cursor: pointer;
`;

export const HintNomenclature = styled.span`
  font-family: Open Sans;
  font-style: normal;
  font-weight: 600;
  font-size: 11px;
  float: left;
  margin: 8px 0 0 28px;
  color: ${({ theme }) => theme.colors.surface.onSurfaceVariant};
`;
